import * as React from "react";
import { Avatar, Button, Layout, Space, Typography } from "antd";
import bankLogo from "../assets/images/bank-logo.png";
import LanguagePicker from "./settings/LanguagePicker";
import { LogoutOutlined } from "@ant-design/icons";

const AntHeader = Layout.Header;
const { Title } = Typography;

const Header = ({
  title,
  buttonTitle,
  buttonClick,
  languagePickerVisible,
  onLanguageChange,
  language
}: {
  title?: string;
  languagePickerVisible: boolean;
  buttonTitle?: string;
  buttonClick?: any;
  onLanguageChange?: any;
  language?: string;
}) => {
  return (
    <AntHeader
      className="header-wrapper"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}
    >
      <Space>
        <Avatar
          className="header-avatar"
          src={bankLogo}
          shape="square"
          size="large"
          alt="bank-logo"
        />
        <Title level={3}>{title}</Title>
      </Space>
      <Space>
        {languagePickerVisible && (
          <LanguagePicker
            onLanguageChange={onLanguageChange}
            language={language}
            key="header-language-picker"
          />
        )}
        {buttonTitle && (
          <Button
            key="header-btn"
            onClick={buttonClick}
            icon={<LogoutOutlined />}
            className="header-wrapper-button"
          >
            {buttonTitle}
          </Button>
        )}
      </Space>
    </AntHeader>
  );
};

export default Header;
